module.exports = __webpack_public_path__ + "img/tag.9d8bdab8.svg";